/*
 * @Author: wm wangmiao@caigou2003.com
 * @Date: 2025-09-24 17:19:59
 * @LastEditors: wm wangmiao@caigou2003.com
 * @LastEditTime: 2025-09-24 17:22:25
 * @FilePath: \jctt-pc\src\utils\searchGoods.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import api from '@/api/index'

/**
 * 格式化时间戳为月日时分格式
 * @param {number} time - 时间戳
 * @returns {string} 格式化后的时间字符串
 */
function gettime(time) {
  var date = new Date(time * 1000);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var h = date.getHours();
  h = h < 10 ? "0" + h : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? "0" + minute : minute;
  second = second < 10 ? "0" + second : second;
  return m + "月" + d + "日 " + h + ":" + minute;
}

/**
 * 获取商品详情信息
 * @param {string|number} id - 商品ID
 * @returns {Promise} 返回处理后的商品详情数据
 */
export function getShopGoods(id) {
  return new Promise((resolve, reject) => {
    const data = {
      id: id,
    };
    
    api.shopgoods(data)
      .then((res) => {
        if (res.code == 0) {
          // 处理预售详情时间格式化
          if (res.data.pre_detail) {
            if (res.data.pre_detail.final_start_time) {
              res.data.pre_detail.deposit_start_time_format =
                gettime(res.data.pre_detail.deposit_start_time) +
                "-" +
                gettime(res.data.pre_detail.deposit_end_time);
              res.data.pre_detail.final_end_time_format =
                gettime(res.data.pre_detail.final_start_time) +
                "-" +
                gettime(res.data.pre_detail.final_end_time);
              res.data.pre_detail.deliver_time_format = gettime(
                res.data.pre_detail.deliver_time
              );
            }
          }
          
          // 处理封面图片
          if (!res.data.cover_pic && res.data.pic_list[0]) {
            res.data.cover_pic = res.data.pic_list[0].pic_url;
          }
          
          // 处理商品属性
          if (res.data.attr) {
            try {
              res.data.parsed_attr = JSON.parse(res.data.attr);
            } catch (e) {
              console.warn('解析商品属性失败:', e);
              res.data.parsed_attr = [];
            }
          }
          
          // 处理分类列表
          res.data.cat_list = res.data.cat_list || [];
          
          resolve(res.data);
        } else {
          reject(res);
        }
      })
      .catch((err) => {
        console.error('获取商品详情失败:', err);
        reject(err);
      });
  });
}

export default {
  getShopGoods
}